import logo from "../../../assets/images/logo.svg";
import { useLanguage } from "../../../context/LanguageProvider";
import Wrapper from "../../../shared/components/layout/Wrapper";

// Copyright line under the card (same translation keys as the Footer)
const Copyright = () => {
    const { t } = useLanguage();

    return (
        <Wrapper className="flex-col">
            <div className="relative w-full mb-8 justify-center md:text-lg text-md lg:text-lg flex">
                {t.codepro.allrights}
                <span className="flex items-center ml-2 mr-2 text-light-primary">
                    <span>{t.blog.team}</span>
                    <img src={logo} alt="" className="h-6 block mr-2 rounded-sm" />
                </span>
                {t.codepro.reserved}
                &copy;
            </div>
        </Wrapper>
    );
};

export default Copyright;